import storage from 'redux-persist/lib/storage'
import { persistReducer } from 'redux-persist'
import { INITIAL_STATE as loginReducersInitialState } from '~/store/modules/login/reducers'
import { INITIAL_STATE as storeReducersInitialState } from '~/store/modules/store/reducers'
import { INITIAL_STATE as campaignReducersInitialState } from '~/store/modules/campaign/reducers'
import { INITIAL_STATE as voucherReducersInitialState } from '~/store/modules/voucher/reducers'
import { INITIAL_STATE as dashboardReducersInitialState } from '~/store/modules/dashboard/reducers'

const expireReducer = require('redux-persist-expire')

export default reducers => {
  const persistedReducer = persistReducer(
    {
      key: 'root',
      storage,
      version: '2021-01-25_14:30',
      blacklist: ['voucherReducers'],
      transforms: [
        expireReducer('loginReducers', {
          expireSeconds: 3600,
          autoExpire: true,
          expiredState: loginReducersInitialState
        }),
        expireReducer('storeReducers', {
          expireSeconds: (3600 * 12),
          autoExpire: true,
          expiredState: storeReducersInitialState
        }),
        expireReducer('campaignReducers', {
          expireSeconds: (3600 * 12),
          autoExpire: true,
          expiredState: campaignReducersInitialState
        }),
        expireReducer('voucherReducers', {
          expireSeconds: (3600 * 12),
          autoExpire: true,
          expiredState: voucherReducersInitialState
        }),
        expireReducer('dashboardReducers', {
          expireSeconds: (3600 * 12),
          autoExpire: true,
          expiredState: dashboardReducersInitialState
        })
      ]
    },
    reducers
  )

  return persistedReducer
}
